<script>


export default {
  name: 'NavigationItem',

  props: {
    title: {
      required: true,
      type: String,
      default: '',
    },
    url: {
      required: true,
      type: String,
      default: '',
    },
    isActive: {
      required: true,
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      inactiveClasses: 'relative group flex block mt-4 lg:inline-block lg:mt-0 hover:text-blue-light lg:ml-8 p-1 mb-1',
      activeClasses: 'relative group flex block mt-4 lg:inline-block lg:mt-0 lg:ml-8 p-1 text-orange lg:border-b-6 border-orange mr-auto',
    };
  },
};
</script>

<template>
  <a :href="url" :class="isActive ? activeClasses : inactiveClasses" :aria-label="title">
    <slot name="icon" class="grow-0"></slot>

    <span class="grow-0 lg:hidden my-auto ml-2 text-xl">
            {{ title }}
        </span>

    <span
        class="hidden lg:block absolute right-0 top-full mt-2 px-2 py-1 rounded bg-black text-white text-xs whitespace-nowrap opacity-0 pointer-events-none group-hover:opacity-100 group-focus:opacity-100 z-50"
    >
            {{ title }}
        </span>
  </a>
</template>